import './index.css';
import '@fortum/elemental-ui/FortumSans.css';
import './fortumFontOverrides.css';
import React, { Suspense } from 'react';
import { createRoot } from 'react-dom/client';
import { AppInsightsErrorBoundary } from '@microsoft/applicationinsights-react-js';
import { GeneralError } from '@pages/index';
import { reactPlugin } from '@configs/azureAppInsights/appInsights';
import { queryClient } from '@configs/queryClient';
import { QueryClientProvider } from '@tanstack/react-query';
import reportWebVitals from './reportWebVitals';
import './configs/i18n';
import { Router } from './routers';

const ReactQueryDevtools =
  process.env.NODE_ENV === 'development'
    ? React.lazy(() =>
        import('@tanstack/react-query-devtools').then(module => ({
          default: module.ReactQueryDevtools,
        })),
      )
    : null;

const root: HTMLElement | null = document.getElementById('root');

if (root) {
  createRoot(root).render(
    <React.StrictMode>
      <Suspense fallback={<div />}>
        <QueryClientProvider client={queryClient}>
          <AppInsightsErrorBoundary
            onError={GeneralError}
            appInsights={reactPlugin}
          >
            <Router />
          </AppInsightsErrorBoundary>
          {ReactQueryDevtools ? (
            <Suspense fallback={null}>
              <ReactQueryDevtools initialIsOpen={false} />
            </Suspense>
          ) : null}
        </QueryClientProvider>
      </Suspense>
    </React.StrictMode>,
  );
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
